'use client';

import type { PlantSeedStarting } from '@/data/plants';
import { useAuth } from '@/components/AuthProvider';
import { UpgradeNudge } from '@/components/PremiumGate';
import PlantSeedStartingNotes from '@/components/PlantSeedStartingNotes';
import { isProUser } from '@/lib/auth';

function SeedStartingUpgradePrompt() {
  return (
    <div className="pt-4 mt-4 border-t border-sand">
      <UpgradeNudge
        title="Detailed Seed Starting Guidance"
        body="Get step-by-step guidance for starting, transplanting, and establishing this plant successfully."
      />
    </div>
  );
}

export default function GatedSeedStartingNotes({
  seedStarting,
}: {
  seedStarting?: PlantSeedStarting;
}) {
  const { user, loading } = useAuth();

  if (!seedStarting) return null;
  if (loading) return null;

  if (user && isProUser(user)) {
    return <PlantSeedStartingNotes seedStarting={seedStarting} />;
  }

  return <SeedStartingUpgradePrompt />;
}
